import React from 'react';

const NotFound = () => {
    return (
        <div>
            <p>404 Not Found</p>
        </div>
    );
};

export default NotFound;
